<template>
  <div>
    <div class="text-h5">Мои чеки</div>
    <v-row>
      <v-col cols="6" sm="6" md="4">
        <v-dialog
          ref="dialogStart"
          v-model="modalStart"
          :return-value.sync="dateStart"
          persistent
          width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateStart"
              label="c:"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dateStart"
            @input="
              modalStart = false;
              $refs.dialogStart.save(dateStart);
              this.getList();
            "
            no-title
            scrollable
            locale="ru-ru"
            :first-day-of-week="1"
          ></v-date-picker>
        </v-dialog>
      </v-col>

      <v-col cols="6" sm="6" md="4">
        <v-dialog
          ref="dialogEnd"
          v-model="modalEnd"
          :return-value.sync="dateEnd"
          persistent
          width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateEnd"
              label="по:"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dateEnd"
            @input="
              modalEnd = false;
              $refs.dialogEnd.save(dateEnd);
            "
            no-title
            scrollable
            locale="ru-ru"
            :first-day-of-week="1"
          ></v-date-picker>
        </v-dialog>
      </v-col>
    </v-row>

    <v-alert v-if="checks.length < 1" type="error"
      >Нет данных за выбранный период</v-alert
    >

    <div v-show="loading" class="progress-logo">
      <v-layout align-center justify-center column fill-height>
        <v-progress-circular
          indeterminate
          color="primary"
          :size="70"
          :width="5"
        ></v-progress-circular>
      </v-layout>
    </div>

    <div v-if="!loading">
      <check-cash-amount v-if="cashAmount !== null" :cash-amount="cashAmount" />
      <v-alert v-if="checks.length > 0" type="success" class="top20"
        >Итого: {{ totalSum }} <span class="currency-rub"></span
      ></v-alert>
      <check-list-row v-for="check in checks" :key="check.id" :check="check" />
    </div>
  </div>
</template>

<script>
import CheckListRow from "@/components/CheckListRow";
import CheckCashAmount from "@/components/CheckCashAmount";

export default {
  name: "CheckList",
  components: { CheckCashAmount, CheckListRow },
  data: () => ({
    dateStart: new Date(
      new Date().getTime() - new Date().getTimezoneOffset() * 60000
    )
      .toISOString()
      .substr(0, 10),
    dateEnd: new Date(
      new Date().getTime() + 86400000 - new Date().getTimezoneOffset() * 60000
    )
      .toISOString()
      .substr(0, 10),
    modalEnd: false,
    modalStart: false,
    loading: false,
    checks: [],
    cashAmount: null,
  }),
  created: function () {
    this.getList();
    this.checks = this.$store.getters.checks;
  },
  computed: {
    totalSum() {
      return this.$store.getters.totalSum;
    },
  },
  watch: {
    dateStart: function () {
      this.getList();
    },
    dateEnd: function () {
      this.getList();
    },
  },
  methods: {
    getList() {
      this.loading = true;
      this.$store
        .dispatch("get_driver_pko", {
          start: this.dateStart,
          end: this.dateEnd,
        })
        .then(() => {
          this.checks = this.$store.getters.checks;
          this.cashAmount = this.$store.getters.cashAmount;
        })
        .catch(() => {
          this.checks = this.$store.getters.checks;
          this.sum = 0;
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
